<template>
    <collapsible-card :title="'Voyage'" class="voyageWidth" v-show="voyage.length > 0" ref="cCard">
        <div class="cardContent">
            <div class="category">
                <h3 class="categoryTitle">Recent</h3>
                <div v-for="obj in voyage" :key="obj.field" class="dataItem">
                    <p v-if="obj.val">{{obj.field}}: <span class="dataEmphasis">{{obj.val}}</span></p>
                    <p v-else><span class="dataEmphasis">{{obj.field}}</span></p>
                </div>
                <div class="note"> 
                    <p>
                        According to AIS message received on {{updatedAt}}
                    </p>
                    <p v-if="aisVer">
                        with AIS Version {{aisVer}}
                    </p>
                </div>
            </div>
            <div class="category" v-show="count6Month != null && count6Month != undefined && count6Month >= 0">
                <h3 class="categoryTitle" style="margin-bottom: 10px;">Last 6 Months</h3>
                <p v-if="count6Month == 1">{{name}} has completed <span class="dataEmphasis">{{count6Month}}</span> voyage in the last 6 months</p>
                <p v-else>{{name}} has completed <span class="dataEmphasis">{{count6Month}}</span> voyages in the last 6 months</p>
            </div>
        </div>
    </collapsible-card>
</template>

<script>
import {readFromObj, formatDateLT, formatDateUTC} from '../../helpers/Formatting.js';
import CollapsibleCard from '../CollapsibleCard.vue';

export default {
    name: "vessel-voyage",
    components: {
        CollapsibleCard
    },
    data: () => ({
        aisVer: "",
        name: "The vessel",
        updatedAt: "",
        voyage: [],
        count6Month: null,
    }),
    methods: {
        updateInfo: function(voyageInfo, aisVer, name="The vessel") {
            var globv = this;

            globv.aisVer = aisVer;
            globv.name = name;
            globv.updatedAt = formatDateUTC(voyageInfo['recent']['updatedAt']);

            let expectedVariables = [
                {
                    varName: "destination",
                    fieldName: "Destination"
                },
                {
                    varName: "eta",
                    fieldName: "ETA",
                    format: formatDateLT
                },
                {
                    varName: "recognizedPort.unlocode",
                    fieldName: "Port UN/LOCODE"
                }
            ]

            globv.voyage = readFromObj(voyageInfo['recent'], expectedVariables);
            globv.count6Month = voyageInfo['last6Months']['count'];
            globv.$refs.cCard.adjustHeight();
        },
        reset: function() {
            var globv = this;
            globv.aisVer = "";
            globv.updatedAt = "";
            globv.voyage = [];
        }
    }
}
</script>

<style lang="scss">
.voyageWidth {
    width: 435px;
}
</style>